import React, { useState, useEffect } from "react";

const brands = [
  {
    brand: "Maruti Suzuki",
    models: ["Swift", "Baleno", "Wagon R", "Dzire", "Ertiga", "Others"],
  },
  {
    brand: "Hyundai",
    models: ["Creta", "i20", "Venue", "Verna", "Santro", "Others"],
  },
  {
    brand: "Tata Motors",
    models: ["Nexon", "Harrier", "Altroz", "Punch", "Tiago", "Others"],
  },
  {
    brand: "Mahindra",
    models: ["XUV700", "Thar", "Scorpio", "Bolero", "XUV300", "Others"],
  },
  {
    brand: "Toyota",
    models: ["Innova Crysta", "Fortuner", "Glanza", "Urban Cruiser", "Camry", "Others"],
  },
  {
    brand: "Kia",
    models: ["Seltos", "Sonet", "Carens", "Carnival", "Others"],
  },
  {
    brand: "Honda",
    models: ["City", "Amaze", "WR-V", "Jazz", "Others"],
  },
  {
    brand: "Chavrolet",
    models: ["Hector", "Astor", "ZS EV", "Gloster", "Others"],
  },
  {
    brand: "Volkswagen",
    models: ["Virtus", "Taigun", "Polo", "Vento", "Others"],
  },
  {
    brand: "Skoda",
    models: ["Kushaq", "Slavia", "Octavia", "Superb", "Others"],
  },
  {
    brand: "Renault",
    models: ["Kwid", "Triber", "Kiger", "Duster", "Others"],
  },
  {
    brand: "Nissan",
    models: ["Magnite", "Kicks", "Others"],
  },
  {
    brand: "Ford",
    models: ["EcoSport", "Endeavour", "Others"],
  },
  {
    brand: "Mercedes-Benz",
    models: ["C-Class", "E-Class", "GLA", "GLC", "GLE", "Others"],
  },
  {
    brand: "BMW",
    models: ["3 Series", "X1", "X5", "5 Series", "Others"],
  },
  {
    brand: "Audi",
    models: ["A4", "Q3", "Q5", "A6", "Others"],
  },
  {
    brand: "Volvo",
    models: ["XC40", "XC60", "S60", "Others"],
  },
  {
    brand: "Jaguar",
    models: ["XF", "F-Pace", "I-Pace", "Others"],
  },
  {
    models: ["Others"]
  }
];

const Model = ({ onSelect }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredModels, setFilteredModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");

  useEffect(() => {
    const brandFromLocalStorage = localStorage.getItem("selectedBrand");
    if (brandFromLocalStorage) {
      setSelectedBrand(brandFromLocalStorage);
    }
  }, []);

  useEffect(() => {
    if (selectedBrand) {
      const brandData = brands.find((brand) => brand.brand === selectedBrand);
      setFilteredModels(brandData ? brandData.models : []);
    }
  }, [selectedBrand]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleModelClick = (model) => {
    onSelect("model", model);
  };

  const filteredResults = filteredModels.filter((model) =>
    model.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <section
      style={{
        fontFamily: "Barlow Condensed",
        height: "40rem",
        maxHeight: "90vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
      className="overflow-y-auto"
    >
      <h4
        style={{ fontFamily: "Ballega" }}
        className="text-center text-2xl sm:text-3xl mb-8"
      >
        Select the Model of the car
      </h4>
      <div className="relative mb-8 flex justify-center items-center">
        <input
          type="search"
          placeholder="SEARCH FOR THE BRAND"
          aria-label="Search"
          value={searchQuery}
          onChange={handleSearchChange}
          className="w-full px-4 py-4 text-center placeholder-gray font-bold text-lg border border-black rounded-lg text-sm focus:ring focus:ring-black-200 focus:outline-none"
        />
        <span className="absolute right-16 sm:right-52 lg:right-96 flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="2"
            stroke="currentColor"
            className="w-5 h-5 text-black"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-4.35-4.35M9 16a7 7 0 100-14 7 7 0 000 14z"
            />
          </svg>
        </span>
      </div>
      <h4 style={{ fontFamily: "Ballega" }} className="text-2xl sm:text-3xl mb-8">
        Popular Models
      </h4>
      <div
        className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 sm:px-16"
        style={{ fontFamily: "Ballega" }}
      >
        {filteredResults.length > 0 ? (
          filteredResults.map((model) => (
            <button
              key={model}
              className="p-4 text-2xl sm:text-3xl border border-black rounded-md hover:bg-sky-300"
              onClick={() => handleModelClick(model)}
            >
              {model}
            </button>
          ))
        ) : (
          <p className="col-span-3 text-center text-gray-500">
            No models found.
          </p>
        )}
      </div>
    </section>
  );
};

export default Model;
